class GeofenceRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "Geofence";
    const model = App.Models.Geofence;
    const collectionClass = App.Collections.Geofences;

    super(entityName, model, collectionClass);
  }

  beforeInitializeGrid = () => {
    const formGeofence = document.querySelector("#st-container");
    formGeofence && formGeofence.remove();
   }

  form_new = () => {
    if (this.checkHavePermissionToOpenTab("Geofence", "new")) {
      this.renderForm();
    } else {
      window.location = "#/AccessDenied/401";
    }
  };

  edit = id => {
    if (this.checkHavePermissionToOpenTab("Geofence", "edit")) {
      const callback = geofenceObject => this.renderForm(geofenceObject);
      this.getGeofenceById(id, callback);
    } else {
      window.location = "#/AccessDenied/401";
    }
  };

  renderForm = geofenceObject => {
    const entity = "Geofence";
    const render = async () => {
      await this.getOrganizations();
      App.Views.Geofence.render(
        geofenceObject,
        Monet.Session.GeofenceMaps.organizations
      );
    };
    const appForms = App.Forms[entity];
    if (!appForms || !appForms.layout["new"] || !appForms.layout["edit"]) {
      App.Forms[entity] = appForms || {};
      App.Forms[entity].layout = {};
      if (geofenceObject) {
        this.getLayout(render, "edit");
      } else {
        this.getLayout(render, "new");
      }
    } else {
      render();
    }
  };

  getOrganizations = async () => {
    if (!Monet.Session.GeofenceMaps) {
      Monet.Session.GeofenceMaps = {};
    }

    const ajax = new Monet.Ajax();
    ajax.url = "Organization/retrieveUserOrganizationsByDescription";
    ajax.method = "GET";
    ajax.success = function(data) {
      if (data) {
        Monet.Session.GeofenceMaps.organizations = data;
      }
    };
    ajax.error = responseText =>
      this.showErrorExceptionOnPopupForm(responseText);
    await ajax.send();
  };

  getLayout = (callback, action) => {
    var entity = "Geofence";
    var ajax = new Monet.Ajax();

    ajax.url = "form/" + entity + "/" + action;
    ajax.method = "GET";

    ajax.success = function(layout) {
      if (layout) {
        App.Forms[entity].layout[action] = layout;
        var dm = new Monet.Builder.DataMapper();
        dm.setEntity(entity);
        dm.build(callback, layout);
      }
    };

    ajax.send();
  };

  save = () => {
    var method = "POST";
    var jsonObject = { geofenceGeometry: { positions: [] } };
    var form = Monet.Session.GeofenceMaps.form;
    var fieldValues = form.getValues();
    var allowSubmit = form.validate();

    jsonObject = this.getPositions(jsonObject);

    this.clearErrorMessage();

    if (!jsonObject) {
      allowSubmit.errorMessages.push({
        resource: {
          i18nMessage: Monet.I18n.getResourcesByKey("geofence.mustDraw")
        }
      });
      allowSubmit.status = false;
    }

    if (allowSubmit.status) {
      form.triggerLoadingBtns();
      for (var x in fieldValues) {
        if (fieldValues.hasOwnProperty(x)) {
          jsonObject[x] = fieldValues[x];
        }
      }
      if (fieldValues.id) {
        method = "PUT";
      }
      this.sendRequest(method, jsonObject);

      setTimeout(() => {
        form.triggerLoadingBtns();
      }, 1500);
    } else {
      var monetMessage = new Monet.Form.Messages.InlineMessage();
      monetMessage.setScope("#Geofence");
      monetMessage.setInfoType("error");
      monetMessage.setMessage(allowSubmit);
      monetMessage.triggerMessage();
    }
  };

  getPositions = jsonObject => {
    var layerGroup = Monet.Session.GeofenceMaps.featureGroup;
    var layer = layerGroup.getLayers()[0];

    if (layer) {
      var latlngs = layer.getLatLngs();

      if (latlngs && latlngs.length > 0) {
        latlngs[0].forEach(coord => {
          const point = {
            latitude: coord.lat,
            longitude: coord.lng
          };
          jsonObject.geofenceGeometry.positions.push(point);
        });

        var firstPosition = jsonObject.geofenceGeometry.positions[0];
        jsonObject.geofenceGeometry.positions.push(firstPosition);
      }

      return jsonObject;
    }
  };

  sendRequest = (method, jsonObject) => {
    var entity = "Geofence";
    var id = jsonObject.id ? "/" + jsonObject.id : "";

    var ajax = new Monet.Ajax();
    ajax.url = entity + id;
    ajax.method = method;
    ajax.data = jsonObject;

    ajax.success = function() {
      window.location = "#/Geofence";
    };

    ajax.error = function(xhr) {
      Monet.Configurations.errorNotification(null, xhr, null, null);
    };

    ajax.send();
  };

  getGeofenceById = (id, callback) => {
    var entity = "Geofence";

    var ajax = new Monet.Ajax();
    ajax.url = entity + "/" + id;
    ajax.method = "GET";

    ajax.success = function(data) {
      if (data) {
        callback(data);
      }
    };

    ajax.error = function(xhr) {
      Monet.Configurations.errorNotification(null, xhr, null, null);
    };

    ajax.send();
  };

  clearErrorMessage = () => {
    var divErrors = document.querySelector(
      "#Geofence .monetInlineAlerContainer"
    );
    if (divErrors.firstChild) {
      divErrors.removeChild(divErrors.firstChild);
    }
  };
}

App.Routers.Geofence = GeofenceRouter;
